import { request } from '@umijs/max';
import commonLog from './common-log';

export async function queryUserService(params: any) {
  return request(`${commonLog.userService}`, {
    params,
  });
}

// 获取portal下的审计log记录
export async function queryLogService(data: any) {
  return request('/logs/audit', {
    method: 'POST',
    data,
  });
}
